import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import { ButtonContainer } from "../PriceAction/PriceAction.styled";
import treatmentIcon from "@icons/ic-treatment.svg";
import treatmentTransportIcon from "@icons/ic-transport-treatment.svg";
import unknownIcon from "@icons/ic-unknown.svg";
import transportIcon from "@icons/ic-transport-only.svg";
import {
  DivBackgroundLowOpacity,
  DivBackgroundFullOpacity,
} from "@utils/extra-style";
import "../../PriceList.scss";

const PriceType = (props) => {
  const { t, data } = props;
  return (
    <>
      {data.isActive == 0 && (
        <DivBackgroundLowOpacity>
          <ButtonContainer>
            {data.type === 1 && (
              <Image
                src={treatmentIcon}
                alt={t("CENTRE_PRODUCT_PRICE_TREATMENT")}
                title={t("CENTRE_PRODUCT_PRICE_TREATMENT")}
                className="center-product-price-list__image-icon"
              />
            )}
            {data.type === 2 && (
              <Image
                src={treatmentTransportIcon}
                alt={t("CENTRE_PRODUCT_PRICE_TRANSPORT_TREATMENT")}
                title={t("CENTRE_PRODUCT_PRICE_TRANSPORT_TREATMENT")}
                className="center-product-price-list__image-icon"
              />
            )}
            {data.type === 3 && (
              <Image
                src={unknownIcon}
                alt={t("CENTRE_PRODUCT_PRICE_UNKNOWN")}
                title={t("CENTRE_PRODUCT_PRICE_UNKNOWN")}
                className="center-product-price-list__image-icon"
              />
            )}
            {data.type === 4 && (
              <Image
                src={transportIcon}
                alt={t("CENTRE_PRODUCT_PRICE_TRANSPORT")}
                title={t("CENTRE_PRODUCT_PRICE_TRANSPORT")}
                className="center-product-price-list__image-icon"
              />
            )}
          </ButtonContainer>
        </DivBackgroundLowOpacity>
      )}
      {data.isActive == 1 && (
        <DivBackgroundFullOpacity>
          <ButtonContainer>
            {data.type === 1 && (
              <Image
                src={treatmentIcon}
                alt={t("CENTRE_PRODUCT_PRICE_TREATMENT")}
                title={t("CENTRE_PRODUCT_PRICE_TREATMENT")}
                className="center-product-price-list__image-icon"
              />
            )}
            {data.type === 2 && (
              <Image
                src={treatmentTransportIcon}
                alt={t("CENTRE_PRODUCT_PRICE_TRANSPORT_TREATMENT")}
                title={t("CENTRE_PRODUCT_PRICE_TRANSPORT_TREATMENT")}
                className="center-product-price-list__image-icon"
              />
            )}
            {data.type === 3 && (
              <Image
                src={unknownIcon}
                alt={t("CENTRE_PRODUCT_PRICE_UNKNOWN")}
                title={t("CENTRE_PRODUCT_PRICE_UNKNOWN")}
                className="center-product-price-list__image-icon"
              />
            )}
            {data.type === 4 && (
              <Image
                src={transportIcon}
                alt={t("CENTRE_PRODUCT_PRICE_TRANSPORT")}
                title={t("CENTRE_PRODUCT_PRICE_TRANSPORT")}
                className="center-product-price-list__image-icon"
              />
            )}
          </ButtonContainer>
        </DivBackgroundFullOpacity>
      )}
    </>
  );
};

PriceType.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(PriceType);
